
export const setFeatures = (state, features) =>{
    state.features = features;
}
